<div class="__new__header__top __new__header__top2024">
    <div class="section">
        <div class="__new__header__top-inner">
            <div>
                <a href="/" class="__new__header__top-logo">
                    <img ngSrc="/assets/images/svg/logoMainDark.svg" alt="НДВ супермаркет недвижимости" width="222" height="48"
                         priority="high">
                    <img ngSrc="/assets/images/svg/logoMainMobile.svg" alt="НДВ супермаркет недвижимости" class="__new__header__top-logo__logo-mobile" width="150" height="32">
                </a>
            </div>

          <button class="intro__btn-city" (click)="getLocation()">
            <app-ui-icon [name]="'icon-city'" [width]="'16'"></app-ui-icon>
            <span>{{ locationCity }}</span>
          </button>

            <div>
                <div class="__new__header__top-buttons">
                    <!--Поиск-->
                    <a href="javascript:" class="__new__header__top-buttons__link js-search-modal-form" (click)="openDialog()" data-src="#searchHeader" data-touch="false">
                        <img ngSrc="/assets/images/svg/search-icon-white.svg" alt="Поиск" width="24" height="24">
<!--                        <span class="__new__header__top-buttons__link-text">Поиск</span>-->
                    </a>

                    <!--Избранное-->
                    <div class="__new__header__top-buttons-inner">
                        <a href="{{ getFavoritePath() }}"
                           class="__new__header__top-buttons__link __new__header__top-buttons__link--favorite js-favoriteLink {{ isNoFavorites() }}">
                            <img ngSrc="/assets/images/svg/heart-white.svg" alt="Избранное" width="20" height="20">
                            <span class="__new__header__top-buttons__counter js_headerFavoritesCounter">{{ getFavouriteCount() }}</span>
                        </a>

                        <div class="__new__header__top-buttons__separator"></div>

                        <!--Разместить объявление-->
                        <a href="{{ getAddLink() }}" class="__new__header__top-buttons__link __new__header__top-buttons__link--place-ad">
                            <img ngSrc="/assets/images/svg/circle-plus-white.svg" alt="Избранное" width="20" height="20">
                            <span class="__new__header__top-buttons__link-text">Разместить объявление</span>
                        </a>

                        <div class="__new__header__top-buttons__separator"></div>

                        <!--Авторизация и меню пользователя-->
                      <ng-container *ngIf="isUserAuthorized() ; else unAuthorizedBlock">
                        <!--авторизованный пользователь-->
                        <div class="__new__header__top-buttons__link __new__header__user">
                          <img ngSrc="/assets/images/svg/user-new-white.svg" alt="Войти" width="20" height="20">
                          <span class="__new__header__top-buttons__link-text"><span class="__new__header__user-name">{{ profileData.userPhone }}</span></span>
                          <div class="__new__header__user-menu">
                            <div class="__new__header__user-menu__inner">
                              <a href="//client.ndv.ru" target="_blank" class="__new__header__user-name__user">{{ profileData.userPhone }}</a>
                              <a href="//client.ndv.ru" target="_blank" class="__new__header__user-menu__link __new__header__user-name__hidden">Перейти в кабинет</a>
                              <a href="//client.ndv.ru/cabinet/my-objects" target="_blank" class="__new__header__user-menu__link">Мои сделки</a>
                              <a href="//client.ndv.ru/cabinet/ads-list" target="_blank" class="__new__header__user-menu__link">Мои объявления</a>
                              <a href="//client.ndv.ru/logout?redirect=https://www.ndv.ru" class="__new__header__user-menu__link">Выйти</a>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #unAuthorizedBlock>
                        <a href="https://client.ndv.ru/authentication/start" class="__new__header__top-buttons__link __new__header__top-buttons__link--user">
                          <img ngSrc="/assets/images/svg/user-new-white.svg" alt="Войти" width="20" height="20">
                          <span class="__new__header__top-buttons__link-text">Войти</span>
                        </a>
                      </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
